<template>
  <div>
    <sub-main/>
  </div>
</template>
<script>
import SubMain from '../../canads/terrenos/maplocation/SubMain'
export default {
  name: "SubMenu",
  components: {
    SubMain
  }
}
</script>
<style scoped>
</style>